/**
 * This file is to export constants that are going to be used as paths to get the CRA related values from the company profile object.
 * This is strictly related to DnB only and cannot be used for other data providers.
 */

// country codes are present at different places in different formats
export const countryCodeInArrays = [
  {
    key: 'companyProfile',
    arrayPath: 'addresses',
    fieldPath: 'countryCode',
  },
  {
    key: 'companyProfile',
    arrayPath: 'otherAddresses',
    fieldPath: 'countryCode',
  },
  {
    key: 'companyProfile',
    arrayPath: 'tradingAddresses',
    fieldPath: 'countryCode',
  },
  {
    key: 'directorAndShareDetails.shareholders',
    arrayPath: 'directorAndShareDetails.shareHolders',
    fieldPath: 'countryCode',
  },
  {
    key: 'directorAndShareDetails.directors',
    arrayPath: 'directorAndShareDetails.directors',
    fieldPath: 'countryCode',
  },
  {
    key: 'beneficialOwners',
    arrayPath: 'beneficialOwners',
    fieldPath: 'countryCode',
  },
  // {
  //   key: 'extendedGroupStructure',
  //   arrayPath: 'extendedGroupStructure',
  //   fieldPath: 'countryCode',
  // },
  // {
  //   key: 'ownershipStructure',
  //   arrayPath: 'ownershipStructure',
  //   fieldPath: 'countryCode',
  // },
];

export const countryNamesInArrays = [
  {
    key: 'directorAndShareDetails.shareholders',
    arrayPath: 'directorAndShareDetails.shareHolders',
    fieldPath: 'residenceCountry',
  },
  {
    key: 'directorAndShareDetails.directors',
    arrayPath: 'directorAndShareDetails.directors',
    fieldPath: 'residenceCountry',
  },
  {
    key: 'beneficialOwners',
    arrayPath: 'beneficialOwners',
    fieldPath: 'residenceCountry',
  },
  {
    key: 'directorAndShareDetails.shareholders',
    arrayPath: 'directorAndShareDetails.shareHolders',
    fieldPath: 'country',
  },
  {
    key: 'directorAndShareDetails.directors',
    arrayPath: 'directorAndShareDetails.directors',
    fieldPath: 'country',
  },
  {
    key: 'beneficialOwners',
    arrayPath: 'beneficialOwners',
    fieldPath: 'country',
  },
  // {
  //   key: 'extendedGroupStructure',
  //   arrayPath: 'extendedGroupStructure',
  //   fieldPath: 'residenceCountry',
  // },
  // {
  //   key: 'ownershipStructure',
  //   arrayPath: 'ownershipStructure',
  //   fieldPath: 'residenceCountry',
  // },
];

export const nationalitiesInArrays = [
  {
    key: 'directorAndShareDetails.shareholders',
    arrayPath: 'directorAndShareDetails.shareHolders',
    fieldPath: 'nationality',
  },
  {
    key: 'directorAndShareDetails.directors',
    arrayPath: 'directorAndShareDetails.directors',
    fieldPath: 'nationality',
  },
  {
    key: 'beneficialOwners',
    arrayPath: 'beneficialOwners',
    fieldPath: 'nationality',
  },
];

// industry codes are called activity codes after mapping
export const activityCodePath = 'activity';

// customer type/entity type path
export const customerTypePath = 'legalForm';

export const defaultProductValue = 'Current Accounts';
export const defaultDeliveryChannelValue = 'NON FACE TO FACE';
